import { GroupBy, MetricKey } from './types';

export const CLASSIFICATIONS = ['Active', 'Legacy Active', 'Legacy', 'PoC'] as const;

export const GROUP_BY_API_PARAMS: Record<GroupBy, 'tribe' | 'team' | 'name'> = {
  tribe: 'tribe',
  team: 'team',
  repository: 'name',
};

export const DEFAULT_GROUP_BY: GroupBy = 'repository';
export const REPOSITORY_GROUP_BY: GroupBy = 'repository';

export const METRIC_KEYS: MetricKey[] = [
  'coverage',
  'reliability_rating',
  'security_rating',
  'sqale_rating',
  'code_smells',
];

export const GROUP_BY_OPTIONS: Array<{ key: GroupBy; label: string }> = [
  { key: 'repository', label: 'Repository' },
  { key: 'team', label: 'Team' },
  { key: 'tribe', label: 'Tribe' },
];

export const METRICS: Record<
  MetricKey,
  {
    label: string;
    short: string;
    unit: string;
    helper: string;
    max?: number;
    better: 'higher' | 'lower';
  }
> = {
  coverage: {
    label: 'Code coverage',
    short: 'Coverage',
    unit: '%',
    helper: 'Higher is better',
    max: 100,
    better: 'higher',
  },
  reliability_rating: {
    label: 'Reliability rating',
    short: 'Reliability',
    unit: 'rating',
    helper: 'Lower rating is better',
    max: 5,
    better: 'lower',
  },
  security_rating: {
    label: 'Security rating',
    short: 'Security',
    unit: 'rating',
    helper: 'Lower rating is better',
    max: 5,
    better: 'lower',
  },
  sqale_rating: {
    label: 'Maintainability rating',
    short: 'Maintainability',
    unit: 'rating',
    helper: 'Lower rating is better',
    max: 5,
    better: 'lower',
  },
  code_smells: {
    label: 'Code smells',
    short: 'Code smells',
    unit: 'count',
    helper: 'Lower is better',
    better: 'lower',
  },
};

export const SONAR_SERIES_COLORS = ['#2563eb', '#16a34a', '#f97316', '#7c3aed', '#0891b2', '#dc2626'];